import React from "react";
import axios from "axios";

class Episode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
      episode: {}
    };
  }

  fetch = _ => {
    const { id, season, episode } = this.props.match.params;

    if (this.state.id !== episode) {
      axios
        .get(`tv/${id}/season/${season}/episode/${episode}`)
        .then(response => {
          this.setState({ id: episode, episode: response.data });
          this.props.episode({
            subtitle: response.data.name,
            air_date: response.data.air_date,
            episode_number: response.data.episode_number,
            season_number: response.data.season_number
          });
        });
    }
  };

  componentDidMount() {
    this.fetch();
  }

  componentWillUnmount() {
    this.props.episode({ subtitle: null, air_date: null });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.episode.overview && (
          <div className="shadow p-4 mb-4">
            <p className="font-bold mb-2">Overview</p>
            <p className="whitespace-pre-line">{this.state.episode.overview}</p>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Episode;



// WEBPACK FOOTER //
// ./src/components/Media/TvShow/Episode.js